import React, { useCallback, useEffect, useRef, useState } from 'react';
import { InputStatusModel } from 'features/worksheet/process/job/models';
import { Link } from 'react-router-dom';
import { MdOutlineCancel, MdOutlineCheckCircleOutline } from 'react-icons/md';
import DefaultModal from 'components/Modal/DefaultModal';
import JobChangeStatus from 'features/worksheet/process/job/components/JobChangeStatus';
import { useAppDispatch, useAppSelector } from 'helpers/redux';
import { RootState } from 'app/store';
import withReactContent from 'sweetalert2-react-content';
import Swal from 'sweetalert2';
import {
    getHoldList,
    getHoldWithFilterList,
    getListWithFilter,
} from '../jobCheck.reducer';
import {
    customStatusOption,
    customWarnOption,
    savedStatusOption,
} from 'helpers/alertLabel';
import {
    cancelJob,
    changeStatusJob,
    reset,
} from 'features/worksheet/process/job/job.reducer';
import { HttpClientError, RequestStatus } from 'http-client';
import { DETAIL_TYPE_JOB_INPUT } from '../../../process/job/constants';
import AgDataGrid from '../../../../../components/DataGrid/AgDataGrid';
import { filterParams } from '../../../../../helpers/agTable';
import { rowNumberRenderer } from '../../../../../components/DataGrid/agGridCustomProps';
import { darkGreen, JOB_STATUS_PREP } from '../../../../../constants';
import { checkRoleActionAccess } from '../../../../../routes/checkRoleAccess';
import { ActionEnum, MenuEnum } from '../../../../../routes/models';
import { UserCredential } from '../../../../login/models';
import AgDataGridServerPaging from '../../../../../components/DataGrid/AgDataGridServerPaging';
import { isArrayEmpty } from '../../../../../helpers/checkEmptiness';
import { getSortModel, getSortType } from '../../../../approval/constants';
import { jobCheckSortOption, jobHoldSortOption } from '../constants';
import { dateSetTimeToNow } from '../../../../../helpers/convert';

import {
    completeJob,
    reset as resetJobStatus,
} from 'features/worksheet/processDetail/jobOCalc/jobQC.reducer';
import {
    completeMRE,
    reset as resetJobMREStatus,
} from 'features/worksheet/processDetail/mre/mre.reducer';
import { completeKatapult, reset as resetJobKatapultStatus } from 'features/worksheet/processDetail/katapult/katapult.reducer';

const JobHoldTable = () => {
    const dispatch = useAppDispatch();
    const MySwal = withReactContent(Swal);
    const gridRef = useRef<any>(null);

    const user = useAppSelector(
        (state: RootState) => state.user.userAuth ?? ({} as UserCredential)
    );
    const jobHoldList = useAppSelector(
        (state: RootState) => state.jobCheck.holdList ?? []
    );
    const actionStatus = useAppSelector(
        (state: RootState) => state.job.actionStatus
    );
    const statusJob = useAppSelector((state: RootState) => state.jobQC.status);
    const statusJobMRE = useAppSelector((state: RootState) => state.mre.status);
    const statusJobKatapult = useAppSelector((state: RootState) => state.katapult.status);
    const error = useAppSelector(
        (state: RootState) => state.job.error ?? ({} as HttpClientError)
    );

    const [showModal, setShowModal] = useState<boolean>(false);
    const [action, setAction] = useState<string>('');
    const [jobId, setJobId] = useState<string>('');
    const [tableName, setTableName] = useState('');

    // useEffect(() => {
    //     dispatch(getHoldList({}));
    //     // eslint-disable-next-line react-hooks/exhaustive-deps
    // }, []);

    useEffect(() => {
        if (
            tableName === 'hold' &&
            actionStatus !== undefined &&
            actionStatus !== RequestStatus.pending
        ) {
            MySwal.fire(
                customStatusOption(
                    actionStatus === RequestStatus.success,
                    error.data?.message,
                    'status has been changed!',
                    'failed to change status'
                )
            ).then(() => {
                dispatch(reset());
                // dispatch(getHoldList({}));
                refreshCache(undefined);
                setShowModal(false);
                setTableName('');
            });
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [tableName, actionStatus, error]);

    useEffect(() => {
        if (statusJob !== undefined && statusJob !== RequestStatus.pending) {
            MySwal.fire(
                savedStatusOption(
                    statusJob === RequestStatus.success,
                    error.data?.message
                )
            ).then(() => {
                dispatch(resetJobStatus());
                refreshCache(undefined);
                setShowModal(false);
                setTableName('');
            });
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [statusJob, error]);

    useEffect(() => {
        if (
            statusJobMRE !== undefined &&
            statusJobMRE !== RequestStatus.pending
        ) {
            MySwal.fire(
                savedStatusOption(
                    statusJobMRE === RequestStatus.success,
                    error.data?.message
                )
            ).then(() => {
                dispatch(resetJobMREStatus());
                refreshCache(undefined);
                setShowModal(false);
                setTableName('');
            });
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [statusJobMRE, error]);

        useEffect(() => {
        if (
            statusJobKatapult !== undefined &&
            statusJobKatapult !== RequestStatus.pending
        ) {
            MySwal.fire(
                savedStatusOption(
                    statusJobKatapult === RequestStatus.success,
                    error.data?.message
                )
            ).then(() => {
                dispatch(resetJobKatapultStatus());
                refreshCache(undefined);
                setShowModal(false);
                setTableName('');
            });
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [statusJobKatapult, error]);

    const toggleModal = () => {
        setShowModal((prevState) => !prevState);
        setAction('');
        setJobId('');
    };

    const openModal = (action: string, id: string) => {
        setAction(action);
        setShowModal(true);
        setJobId(id);
    };

    const onStatusClicked = (
        id: string,
        action: string,
        data?: InputStatusModel
    ) => {
        MySwal.fire(
            customWarnOption(
                'Cancel Job',
                'Are you sure you want to cancel this job? You will not be able to recover this later!'
            )
        ).then((result) => {
            if (result.isConfirmed) {
                setTableName('hold');
                dispatch(
                    cancelJob({
                        job_id: id,
                        cancel_notes: data?.notes ?? '',
                        waiting_by_user: user.user_id,
                    })
                );
            }
        });
    };

    const onActionClicked = (job_id: string) => {
        MySwal.fire(
            customWarnOption(
                'Active Job',
                'Are you sure to active this job? You will not be able to recover this later!'
            )
        ).then((result) => {
            if (result.isConfirmed) {
                setTableName('hold');
                dispatch(
                    changeStatusJob({
                        job_id: job_id,
                        status: JOB_STATUS_PREP,
                        userId: user.user_id,
                    })
                );
            }
        });
    };

    const onCompleteClicked = (job_id: string, kind_name: string) => {
        MySwal.fire({
            title: (
                <span>
                    Complete{' '}
                    {kind_name !== 'MRE' && kind_name !== 'Katapult'
                        ? ''
                        : kind_name}{' '}
                    Job!
                </span>
            ),
            html: (
                <div>
                    <span>
                        Are you sure? You will not be able to recover this data!
                    </span>
                </div>
            ),
            icon: 'warning',
            showCancelButton: true,
            cancelButtonColor: darkGreen,
            confirmButtonText: 'Yes',
        }).then((result) => {
            if (result.isConfirmed) {
                if (kind_name === 'MRE') {
                    dispatch(completeMRE(job_id as string));
                } else if (kind_name === 'Katapult') {
                     dispatch(completeKatapult(job_id as string));
                } else {
                    dispatch(completeJob({ job_id: job_id as string }));
                }
            }
        });
    };

    const ActionCellRender = (props: any) => {
        console.log('ActionCellRender Data: ', props.data);
        return (
            <div className="flex align-middle h-[100%]">
                {props.data?.status_name === 'Hold CE' ? (
                    <>
                        {checkRoleActionAccess(
                            user?.roleName,
                            MenuEnum.WorksheetHoldJob,
                            ActionEnum.ActionCheck
                        ) && (
                            <button
                                onClick={() =>
                                    onCompleteClicked(
                                        props.data?.id,
                                        props.data?.kind_name
                                    )
                                }
                            >
                                <MdOutlineCheckCircleOutline className="mr-2 text-2xl text-primary-color" />
                            </button>
                        )}
                    </>
                ) : (
                    <>
                        {checkRoleActionAccess(
                            user?.roleName,
                            MenuEnum.WorksheetHoldJob,
                            ActionEnum.ActionCheck
                        ) && (
                            <button
                                onClick={() => onActionClicked(props.data?.id)}
                            >
                                <MdOutlineCheckCircleOutline className="mr-2 text-2xl text-primary-color" />
                            </button>
                        )}
                        {checkRoleActionAccess(
                            user?.roleName,
                            MenuEnum.WorksheetHoldJob,
                            ActionEnum.ActionCancel
                        ) && (
                            <button
                                onClick={() =>
                                    openModal('cancel', props.data?.id)
                                }
                            >
                                <MdOutlineCancel className=" text-2xl text-primary-color" />
                            </button>
                        )}
                    </>
                )}
            </div>
        );
    };

    const JobNumberLinkCellRender = (props: any) => (
        <Link
            to={`/worksheet/ocalc/job-detail/${props.data?.id}`}
            className="underline text-blue-700"
        >
            {props.data?.number_job}
        </Link>
    );

    const [columnDefs, _setColumnDefs] = useState([
        {
            headerName: '#',
            field: 'rowNumber',
            cellRenderer: rowNumberRenderer, // Use the custom cell renderer
            suppressSizeToFit: true,
            sortable: false,
            filter: false,
        },
        {
            field: 'sales_order',
            headerName: 'Sales Order',
            sortable: false,
            filter: false,
        },
        {
            field: 'number_id',
            headerName: 'ID Number',
            filter: 'agTextColumnFilter',
            filterParams: {
                filterOptions: ['contains'],
                maxNumConditions: 1,
            },
        },
        {
            headerName: 'Job Number',
            field: 'number_job',
            filter: 'agTextColumnFilter',
            filterParams: {
                filterOptions: ['contains'],
                maxNumConditions: 1,
            },
            suppressCellFlash: true,
            cellRenderer: JobNumberLinkCellRender,
        },
        {
            field: 'project_name',
            headerName: 'Project',
            filter: 'agTextColumnFilter',
            filterParams: {
                filterOptions: ['contains'],
                maxNumConditions: 1,
            },
        },
        {
            field: 'kind_name',
            headerName: 'KoJ',
            filter: 'agTextColumnFilter',
            filterParams: {
                filterOptions: ['contains'],
                maxNumConditions: 1,
            },
        },
        {
            field: 'waiting_subject_name',
            headerName: 'Waiting Subject',
            sortable: false,
            filter: false,
        },
        {
            field: 'ts_created',
            headerName: 'Request Date',
            cellDataType: 'date',
            sortable: true,
            filter: 'agDateColumnFilter',
            filterParams: {
                filterOptions: ['inRange'],
                maxNumConditions: 1,
            },
        },
        {
            field: 'status_name',
            headerName: 'Status',
            filter: 'agTextColumnFilter',
            filterParams: {
                filterOptions: ['contains'],
                maxNumConditions: 1,
            },
        },
        {
            field: 'type_name',
            headerName: 'Type',
            sortable: false,
            filter: false,
        },
        {
            field: 'district_name',
            headerName: 'District',
            filter: 'agTextColumnFilter',
            filterParams: {
                filterOptions: ['contains'],
                maxNumConditions: 1,
            },
        },
        {
            field: 'po_number',
            headerName: 'PO Number',
            filter: false,
            sortable: false,
        },
        {
            field: 'department_owner_name',
            headerName: 'Department Owner',
            sortable: false,
            filter: false,
        },
        {
            field: 'hold_by_user_name',
            headerName: 'Hold By',
            sortable: false,
            filter: false,
        },
        {
            field: 'hold_ts',
            headerName: 'Hold Date',
            cellDataType: 'date_time',
            sortable: false,
            filter: false,
        },
        {
            field: 'date_due',
            headerName: 'Due Date',
            cellDataType: 'date',
            sortable: true,
            filter: 'agDateColumnFilter',
            filterParams: {
                filterOptions: ['inRange'],
                maxNumConditions: 1,
            },
        },
        {
            field: 'pole_total',
            headerName: 'Req Pole',
            sortable: false,
            filter: false,
        },
        {
            headerName: 'Actions',
            field: 'actions',
            pinned: 'right',
            suppressCellFlash: true,
            minWidth: 220,
            cellRenderer: ActionCellRender,
            cellStyle: () => ({
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
            }),
        },
    ]);

    const getServerSideDataSource = () => {
        return {
            getRows: (params: any) => {
                const sortModel = isArrayEmpty(params.request.sortModel)
                    ? undefined
                    : getSortModel(
                          jobHoldSortOption,
                          params.request.sortModel[0].colId
                      ) ?? undefined;
                const sortType = isArrayEmpty(params.request.sortModel)
                    ? undefined
                    : getSortType(params.request.sortModel[0].sort) ??
                      undefined;
                const { dateFrom: startDate, dateTo: endDate } =
                    params.request.filterModel?.ts_created || {};
                const { dateFrom: startDueDate, dateTo: endDueDate } =
                    params.request.filterModel?.date_due || {};

                dispatch(
                    getHoldWithFilterList({
                        number_id:
                            params.request.filterModel?.number_id?.filter,
                        number_job:
                            params.request.filterModel?.number_job?.filter,
                        other_number:
                            params.request.filterModel?.other_number?.filter,
                        koj: params.request.filterModel?.kind_name?.filter,
                        project:
                            params.request.filterModel?.project_name?.filter,
                        status: params.request.filterModel?.status_name?.filter,
                        district:
                            params.request.filterModel?.district_name?.filter,
                        startReqDate:
                            startDate !== undefined
                                ? dateSetTimeToNow(startDate)
                                : undefined,
                        endReqDate:
                            endDate !== undefined
                                ? dateSetTimeToNow(endDate)
                                : undefined,
                        startDueDate:
                            startDueDate !== undefined
                                ? dateSetTimeToNow(startDueDate)
                                : undefined,
                        endDueDate:
                            endDueDate !== undefined
                                ? dateSetTimeToNow(endDueDate)
                                : undefined,
                        column:
                            sortModel !== undefined
                                ? parseInt(sortModel ?? '0')
                                : undefined,
                        sort: sortModel !== undefined ? sortType : undefined,
                        skip: params.request.startRow,
                        take: params.api.paginationGetPageSize(),
                    })
                )
                    .then((res: any) => {
                        params.success({
                            rowData: res.payload?.data,
                            rowCount: res.payload.rows,
                        });
                    })
                    .catch((_err: any) => {
                        params.fail();
                    });
            },
        };
    };

    const refreshCache = useCallback((route: any) => {
        const purge = !!document?.querySelector('#purge' as any)?.checked;
        gridRef.current.api.refreshServerSide({ route: route, purge: purge });
    }, []);

    return (
        <div>
            <div className="main-data-grid mt-5">
                {/*<AgDataGrid rowData={jobHoldList} columnDefs={columnDefs} supportSaveTableState tableStateName={'job-data-hold-job'} defaultPageSize={20}/>*/}
                <AgDataGridServerPaging
                    ref={gridRef}
                    columnDefs={columnDefs}
                    getServerSideDataSource={getServerSideDataSource}
                    supportSaveTableState
                    tableStateName={'job-data-hold-job'}
                    defaultPageSize={20}
                />
                <DefaultModal
                    title="Change Status"
                    show={showModal}
                    onClose={toggleModal}
                    body={
                        <JobChangeStatus
                            action={action}
                            jobId={jobId}
                            onSubmit={onStatusClicked}
                        />
                    }
                />
            </div>
        </div>
    );
};

export default JobHoldTable;
